// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import '../node_modules/element-ui/lib/theme-chalk/index.css'
import store from './store'
import qs from 'qs'
import service from './utils/request.js'
import Utils from './utils'
import './utils/utils'
import VXETable from 'vxe-table'
import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx'
import '../node_modules/vxe-table/lib/index.css'
import './styles/index.scss'
import Viewer from 'v-viewer'
import '../node_modules/viewerjs/dist/viewer.css'

Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
VXETable.interceptor.add('event.clear_actived', (params, event) => {
  let path = event.path
  for (let i = 0; i < path.length; i++) {
    if (path[i] && path[i].className && path[i].className.indexOf('el-picker-panel') > -1) {
      return false
    } else if (path[i] && path[i].className && path[i].className.indexOf('el-select-dropdown') > -1) {
      return false
    }
  }
})
Vue.use(VXETable)
VXETable.use(VXETablePluginExportXLSX)
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.axios = service
Vue.prototype.qs = qs
Vue.prototype.Utils = Utils

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js